import { SET_OFFICE_OPEN_INFO } from '@/store/mutation-types'

export default {
	[SET_OFFICE_OPEN_INFO](state, officeOpenInfo) {
		state.officeOpenInfo = officeOpenInfo
	},
}
